import React from 'react';
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Card,
  CardContent,
  Avatar,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Switch,
} from '@mui/material';
import {
  ArrowBack,
  Person,
  Work,
  Notifications,
  Security,
  Logout,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProfilePage: React.FC = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const menuItems = [
    { icon: Person, text: 'Personal Information', action: () => {} },
    { icon: Work, text: 'Job Details', action: () => {} },
    { icon: Notifications, text: 'Notification Settings', action: () => {}, toggle: true },
    { icon: Security, text: 'Change Password', action: () => {} },
  ];

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      <AppBar position="sticky" elevation={0} sx={{ bgcolor: '#1a1a2e' }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={() => navigate(-1)}>
            <ArrowBack />
          </IconButton>
          <Typography variant="h6" sx={{ ml: 2, fontWeight: 700, flexGrow: 1 }}>
            Profile
          </Typography>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 2 }}>
        {/* Profile Header */}
        <Card sx={{ mb: 2, borderRadius: 3, textAlign: 'center' }}>
          <CardContent sx={{ py: 3 }}>
            <Avatar
              sx={{
                width: 100,
                height: 100,
                mx: 'auto',
                mb: 2,
                bgcolor: '#E91E63',
                fontSize: '2.5rem',
              }}
            >
              {user?.name.charAt(0) || 'U'}
            </Avatar>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              {user?.name || 'User'}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {user?.email || 'user@example.com'}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Staff Nurse • ICU Department
            </Typography>
          </CardContent>
        </Card>

        {/* Quick Stats */}
        <Card sx={{ mb: 2, borderRadius: 3 }}>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-around', textAlign: 'center' }}>
              <Box>
                <Typography variant="h5" sx={{ fontWeight: 700, color: '#E91E63' }}>
                  32
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Shifts/Month
                </Typography>
              </Box>
              <Divider orientation="vertical" flexItem />
              <Box>
                <Typography variant="h5" sx={{ fontWeight: 700, color: '#9C27B0' }}>
                  156
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Hours/Month
                </Typography>
              </Box>
              <Divider orientation="vertical" flexItem />
              <Box>
                <Typography variant="h5" sx={{ fontWeight: 700, color: '#FF9800' }}>
                  98%
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Attendance
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>

        {/* Menu Items */}
        <Card sx={{ mb: 2, borderRadius: 3 }}>
          <List>
            {menuItems.map((item, index) => (
              <React.Fragment key={index}>
                <ListItem button onClick={item.action}>
                  <ListItemIcon>
                    <item.icon color="primary" />
                  </ListItemIcon>
                  <ListItemText primary={item.text} />
                  {item.toggle ? (
                    <Switch edge="end" defaultChecked />
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      ›
                    </Typography>
                  )}
                </ListItem>
                {index < menuItems.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        </Card>

        {/* Logout Button */}
        <Card sx={{ borderRadius: 3 }}>
          <ListItem button onClick={handleLogout} sx={{ color: '#E91E63' }}>
            <ListItemIcon>
              <Logout sx={{ color: '#E91E63' }} />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItem>
        </Card>

        <Typography variant="caption" align="center" sx={{ display: 'block', mt: 2, color: 'text.secondary' }}>
          Sakura ShiftSync v1.0.0
        </Typography>
      </Box>
    </Box>
  );
};

export default ProfilePage;
